"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeDateFilterOption = void 0;
var tslib_1 = require("tslib");
var max = function (a, b) { return (a > b ? a : b); };
var min = function (a, b) { return (a <= b ? a : b); };
exports.sanitizeDateFilterOption = function (option) { return (tslib_1.__assign(tslib_1.__assign({}, option), { from: min(option.from, option.to), to: max(option.from, option.to) })); };
//# sourceMappingURL=sanitization.js.map